import React, {useRef} from 'react';
import {Button, Flex, Text} from '@priority-software/priority-style-react';
import noAttachments from '../../../../../../images/noAttachments.svg';
import noAttachmentSearch from '../../../../../../images/noAttachmentSearch.svg';
import texts from '../../texts';
import styles from '../styles/emptyState.module.scss';
import {createDataTestId} from '../../../../../../utils/dataTestId';

interface Props {
    uploadFiles: (file: any) => void;
    isFastSearch: boolean;
}
export const EmptyState = ({uploadFiles, isFastSearch}: Props) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const openFileExplorer = () => {
        if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
        }
    };

    const onFileInputChange = async e => {
        e.preventDefault();
        await uploadFiles(e.target.files);
    };

    return (
        <Flex
            direction={'column'}
            alignItems={'center'}
            justifyContent={'space-between'}
            componentClasses={styles.container}
        >
            <Flex
                direction={'column'}
                alignItems={'center'}
                justifyContent="space-around"
                componentClasses={styles.innerContainer}
            >
                {isFastSearch ? (
                    <>
                        <img
                            src={noAttachmentSearch}
                            alt="No attachments"
                            draggable={false}
                            className={styles.noAttachmentsImg}
                        />
                        <Text
                            skin={'paragraph-1'}
                            textColor="primary-700"
                            componentClasses={styles.textWraper}
                        >
                            {texts.empty_state__search_message}
                        </Text>
                    </>
                ) : (
                    <>
                        <img
                            src={noAttachments}
                            alt="No attachments"
                            draggable={false}
                            className={styles.noAttachmentsImg}
                        />
                        <Text
                            skin={'paragraph-1'}
                            textColor="primary-700"
                            componentClasses={styles.textWraper}
                            {...createDataTestId(`attachments-emptyState-text`, true)}
                        >
                            {texts.empty_state_message}
                        </Text>
                        <Button
                            skin={'secondary'}
                            onClick={openFileExplorer}
                            {...createDataTestId(`attachments-emptyState-btn-attachment`, true)}
                        >
                            {texts.attach_files}
                            <input
                                ref={inputRef}
                                className={styles.input}
                                type="file"
                                onChange={onFileInputChange}
                                multiple
                            />
                        </Button>
                    </>
                )}
            </Flex>
        </Flex>
    );
};
